<template>
    <el-dialog title="Modifier la catégorie" v-loading="loader" :visible.sync="display" width="50%">
        <span>Changer la catégorie pour les {{ items_selected }} produits selectionnés</span>
        <el-form class="row formCategories" ref="form" :model="form">
            <el-form-item prop="category_id" label="Catégorie principale">
                <el-cascader clearable filterable change-on-select :props="{label: 'name', value: 'id'}" :options="categoriesOptions" v-model="form.categories" :filter-method="filterCascader"></el-cascader>
            </el-form-item>

            <el-form-item prop="category_secondary" label="Catégories secondaire">

            </el-form-item>
            <div class="row full-width">
                <div class="col-lg-9">
                    <el-cascader class="full-width" clearable filterable change-on-select :props="{label: 'name', value: 'id'}" :options="categoriesOptions" v-model="form.category_secondary" :filter-method="filterCascader"></el-cascader>
                </div>
                <div class="col-lg-3">
                    <button class="btn btn-outline-success" @click.prevent="addTagCategory">Ajouter</button>
                </div>
            </div>
            <div class="mt-3">
                <el-tag class="ml-3 mb-3" v-for="category in form.categories_secondary" @close="removeTagCategory(category)" :key="category.id" closable>{{category.name}}</el-tag>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <div class="switch-footer">
                <el-switch active-text="Ajouter les sous catégories ?" v-model="form.add"></el-switch>
                <el-switch active-text="Supression des catégories sélectionnées ?" v-model="form.remove"></el-switch>
                <el-switch active-text="Syncronisé ?" v-model="form.sync" ></el-switch>
            </div>

            <div>
                <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
            </div>

        </span>
    </el-dialog>
</template>
<script>
import { filterCascader } from '../../filters';
import { array_dot, array_get } from '../../../utils/array';
import findParentsInArray from '../../../utils/findParentsInArray';
export default {
    data() {
        return {
            display: false,
            loader: false,
            categoriesOptions: [],
            form: {
                categories: [],
                categories_secondary: [],
                category_secondary: [],
                category_id: null,
                add: false,
                remove: false,
                sync: false,
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    mounted() {
        axios.get('/categories').then(r => {
            this.categoriesOptions = r.data.data;
        });
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            this.$confirm("Changer les categories ?", 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    var category_id = this.form.categories[
                    this.form.categories.length - 1
                        ];
                    /*
                    if (!category_id) {
                        this.$message.error('Merci de choisir une catégorie principal');
                        return;
                    }
                    */
                    var products = this.selected.map(v => v.id);
                    var categories = this.form.categories_secondary.map(v => v.id);
                    this.loader = true;
                    var datas = {
                        products,
                        categories: categories,
                        category_id,
                        mode: 'category',
                        add: this.form.add,
                        remove: this.form.remove,
                        sync: this.form.sync,
                    };
                    if (this.applyToAllResult) {
                        datas.filters = this.filters;
                    }
                    datas.total_item = this.total_item
                    datas.items_selected = this.items_selected
                    axios
                        .post('/products/bulk', datas)
                        .then(r => {
                            this.$emit('saved', r);
                            this.$refs.form.resetFields();
                            this.form.categories_secondary = [];
                            this.form.category_secondary = [];
                            this.display = false;
                        })
                        .catch(() => {})
                        .then(() => {
                            this.loader = false;
                        });
                })

        },
        findCategory(categoryId) {
            var categoriesOptions = this.categoriesOptions.slice(0);
            var ar = array_dot(categoriesOptions);
            var category = null;
            for (var key in ar) {
                if (key.match(/\.id$/) && ar[key] == categoryId) {
                    category = array_get(
                        categoriesOptions,
                        key.replace(/\.id$/, '')
                    );
                }
            }
            return category;
        },
        addTagCategory() {
            if (!this.form.category_secondary.length) {
                return;
            }

            var categoryId = this.form.category_secondary[
                this.form.category_secondary.length - 1
            ];
            var category = Object.assign({}, this.findCategory(categoryId));
            var index = this.form.categories_secondary.findIndex(
                v => v.id == category.id
            );

            if (index == -1) {
                this.form.categories_secondary.push(category);
            }
            this.form.category_secondary = [];
        },
        removeTagCategory(category) {
            var index = this.form.categories_secondary.findIndex(
                v => (v.id = category.id)
            );
            this.form.categories_secondary.splice(index, 1);
        },
        filterCascader(node, keyword)
        {
            return filterCascader(node, keyword)
        }
    }
};
</script>
<style lang="scss">
.switch-footer {
    text-align: left;
    margin-bottom: 10px;
}
</style>
